class BrewSteps extends HTMLElement {
    constructor() {
      super();
      this.sliderMobile = this.querySelector(".brew-steps__track");
      this.slider = this.querySelector(".brew-steps__track-wrapper");
      this.sliderItems = this.querySelectorAll(".brew-steps__media-entry");
      this.copySteps = this.querySelectorAll(".brew-steps__copy-step");
      this.prevButton = this.querySelector(".brew-steps__prev");
      this.nextButton = this.querySelector(".brew-steps__next");
  
      this.videoModal = this.querySelector('#PilotVideoModal');
      if(this.videoModal){
        this.videoModalContent = this.videoModal.querySelector('.pilot-video-modal__content');
        this.videoModalClose = this.videoModal.querySelector('.pilot-video-modal__close');
      }
  
      if (!this.slider || !this.sliderItems) {
        console.error("Brew Steps Slider: Slider or Slider Items not found");
        return;
      }
  
      if (!this.prevButton || !this.nextButton) {
        console.log("Brew Steps Slider: Previous or Next button not found");
      }
  
      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);
  
      this.slider.addEventListener("scroll", this.update.bind(this));
      this.sliderMobile.addEventListener("scroll", this.updateMobile.bind(this));
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
      this.copySteps.forEach((step, index) => {
        step.addEventListener("click", (e) => this.onStepClick(e, index));
      });
  
      this.snapToNearestSlide = this.snapToNearestSlide.bind(this);
  
      // product pilots
      this.triggers = this.querySelectorAll('[data-pilot-handle]');
      this.data = JSON.parse(document.getElementById('productPilotsData').textContent);
      this.productPilotsMount = this.querySelector('#product__professionals-cards');
      this.targets = {
        podPrep: this.querySelector('[data-params="brew-step-1"]'),
        grindDose: this.querySelector('[data-params="brew-step-2"]'),
        agitateWait: this.querySelector('[data-params="brew-step-3"]'),
        vacuumFilter: this.querySelector('[data-params="brew-step-4"]'),
        podPrepMobile: this.querySelector("#brew-step-media--1")?.querySelector(".media-entry__body"),
        grindDoseMobile: this.querySelector("#brew-step-media--2")?.querySelector(".media-entry__body"),
        agitateWaitMobile: this.querySelector("#brew-step-media--3")?.querySelector(".media-entry__body"),
        vacuumFilterMobile: this.querySelector("#brew-step-media--4")?.querySelector(".media-entry__body")
      };
  
      this.init();
  
    }
  
    init() {
      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => { this.handleTriggerClick(trigger) });
        const videoUrl = trigger.dataset.videoUrl;
        const playIcon = trigger.querySelector('.product__professional-play-icon');
  
  
        if (videoUrl && playIcon) {
          playIcon.addEventListener('click', (e) => {
            this.openVideoModal(videoUrl);
          });
        }
  
        this.videoModalClose.addEventListener('click', () => this.closeVideoModal());
        this.videoModal.addEventListener('click', (e) => {
          if (e.target === this.videoModal) { // Close if clicking on the backdrop
            this.closeVideoModal();
          }
        });
  
        if (index === 0) {
          this.handleTriggerClick(trigger)
        }
  
      });
    }
  
  
    openVideoModal(url) {
      this.videoModalContent.innerHTML = `<video src="${url}" controls autoplay playsinline></video>`;
      this.videoModal.showModal();
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
  
    closeVideoModal() {
      this.videoModalContent.innerHTML = ''; // Stop video and clear content
      this.videoModal.close();
      document.body.style.overflow = 'initial'; // Allow background scrolling
    }
  
    handleTriggerClick(trigger) {
      const handle = trigger.dataset.pilotHandle;
      this.triggers.forEach(t => t.classList.remove('is-active'));
      trigger.classList.add('is-active');
      this.updateDisplay(handle);
    }
  
    updateDisplay(handle) {
      const pilotData = this.data[handle];
      if (!pilotData) return;
  
      this.targets.podPrep.textContent = pilotData.pod_prep || '--';
      this.targets.grindDose.textContent = pilotData.grind_dose || '--';
      this.targets.agitateWait.textContent = pilotData.agitate_wait || '--';
      this.targets.vacuumFilter.textContent = pilotData.vacuum_filter || '--';

      this.targets.podPrepMobile.textContent = pilotData.pod_prep || '--';
      this.targets.grindDoseMobile.textContent = pilotData.grind_dose || '--';
      this.targets.agitateWaitMobile.textContent = pilotData.agitate_wait || '--';
      this.targets.vacuumFilterMobile.textContent = pilotData.vacuum_filter || '--';

    }
    connectedCallback() {
      console.log('brew steps loaded');
      const track = this.querySelector(".brew-steps__track");
      const trackWrapper = this.querySelector(".brew-steps__track-wrapper");
  
      // Setup slides
      const firstSlide = track.querySelector('.brew-steps__media-entry');
      const slideWidth = firstSlide ? firstSlide.offsetWidth : 0;
      const gap = parseFloat(getComputedStyle(trackWrapper).getPropertyValue('gap')) || 0;
      const slideWidthWithGap = slideWidth + gap;
      const centerOffset = ((slideWidth / 2) - (track.offsetWidth / 2)) + ((track.offsetWidth - trackWrapper.offsetWidth) / 2);
      this.snapToNearestSlide = this.snapToNearestSlide.bind(this, slideWidthWithGap, centerOffset);
      const slideCount = track.querySelectorAll('.brew-steps__media-entry').length;
  
      // Event handling
      let isDown = false;
      let ticking = false;
      let startX;
      let scrollLeft;
  
      track.addEventListener("mousedown", (e) => {
        isDown = true;
        track.classList.add("active");
        startX = e.pageX - track.getBoundingClientRect().left;
        scrollLeft = track.scrollLeft;
      });
  
      track.addEventListener("mouseleave", () => {
        isDown = false;
        track.classList.remove("active");
      });
  
      track.addEventListener("mouseup", () => {
        isDown = false;
        setTimeout(() => {
          this.snapToNearestSlide(track.scrollLeft);
          setTimeout(() => {
            track.classList.remove("active");
          }, 750);
        }, 200);
      });
  
      track.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.getBoundingClientRect().left;
        const walk = (x - startX) * 2;
        track.scrollLeft = scrollLeft - walk;
      });
  
      // product pilots
      if (!this.productPilotsMount || !window.KeenSlider) return;
      this.productPilotsSlider = new KeenSlider(this.productPilotsMount, {
        loop: false,
        mode: 'free-snap',
        slides: {
          perView: 'auto',
          spacing: 15,
        },
      });
    }
  
    initPages() {
      const sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0
      );
      this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
      if (sliderItemsToShow.length === 0) return;
      this.slidesPerPage = Math.floor(
        this.slider.clientWidth / sliderItemsToShow[0].clientWidth
      );
      this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  
    update() {
      if (!this.copySteps || !this.totalPages) return;
      this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;
  
      if (this.currentPage === 1 && this.prevButton) {
        this.prevButton.setAttribute("disabled", true);
      } else if (this.prevButton) {
        this.prevButton.removeAttribute("disabled");
      }
  
      if (this.currentPage === this.totalPages && this.nextButton) {
        this.nextButton.setAttribute("disabled", true);
      } else if (this.nextButton) {
        this.nextButton.removeAttribute("disabled");
      }
  
      this.copySteps.forEach((step) => {
        if (step.id === `brew-step--${this.currentPage}`) {
          step.classList.add("is-active");
        } else {
          step.classList.remove("is-active");
        }
      });
  
      this.sliderItems.forEach((slide) => {
        if (slide.querySelector("video") === null) return;
        const video = slide.querySelector("video");
        if (slide.id === `brew-step-media--${this.currentPage}`) {
          video.play();
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
      console.log('brewSteps updating!!!!')
    }
  
    updateMobile() {
      if (!this.copySteps || !this.totalPages) return;
      this.currentPage =
        Math.round(this.sliderMobile.scrollLeft / this.sliderLastItem.clientWidth) + 1;
  
      if (this.currentPage === 1 && this.prevButton) {
        this.prevButton.setAttribute("disabled", true);
      } else if (this.prevButton) {
        this.prevButton.removeAttribute("disabled");
      }
  
      if (this.currentPage === this.totalPages && this.nextButton) {
        this.nextButton.setAttribute("disabled", true);
      } else if (this.nextButton) {
        this.nextButton.removeAttribute("disabled");
      }
  
      this.copySteps.forEach((step) => {
        if (step.id === `brew-step--${this.currentPage}`) {
          step.classList.add("is-active");
        } else {
          step.classList.remove("is-active");
        }
      });
  
      this.sliderItems.forEach((slide) => {
        if (slide.querySelector("video") === null) return;
        const video = slide.querySelector("video");
        if (slide.id === `brew-step-media--${this.currentPage}`) {
          video.play();
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    }
  
    onButtonClick(e) {
      e.preventDefault();
      const slideScrollPosition =
        e.currentTarget.name === "next"
          ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
          : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition,
        behavior: "smooth",
      });
    }
  
    onStepClick(e, index) {
      e.preventDefault();
      const slideScrollPosition = this.sliderLastItem.clientWidth * index;
      this.slider.scrollTo({
        left: slideScrollPosition,
        behavior: "smooth",
      });
    }
  
    snapToNearestSlide(slideWidthWithGap, centerOffset, currentScroll) {
      const index = Math.round(currentScroll / (slideWidthWithGap + centerOffset));
      const targetScrollPosition = (index * slideWidthWithGap) + centerOffset;
      this.querySelector(".brew-steps__track-wrapper").scrollTo({
        left: targetScrollPosition,
        behavior: "smooth"
      });
    }
  
    disconnectedCallback() {
      if (this.productPilotsSlider) {
        this.productPilotsSlider.destroy();
      }
    }
  
  }
  
  if (!customElements.get('brew-steps')) {
    customElements.define('brew-steps', BrewSteps);
  }
  